<script>
    const image = "images/bwcurling-iron.jpg";
</script>
<style>
    p {
        font-size: 1.5em;
    }
</style>
<div class="welcome flex-row container">
    <div class="welcome-text">
        <p class="center">Welcome to <span class="welcome-emphasis"> A La Mode Studios</span></p>
        <p>If you're looking to book an appointment with one of our stylists</p>
        <a href="#SalonDirectory"><button>Book an Appointment Now</button></a>
        <p>If you're looking to rent a suite from us</p>
        <a href="#Lease"><button>Get More Info Here</button></a>
    </div>
    <div class="welcome-image" style="background-image: url({image}); background-size: cover; flex: 1">

    </div>
</div>